import { type ElementType, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

/** `both` fill keeps the element hidden through its `delay` instead of flashing in first. */
export function Appear(props: { children: ReactNode; delay?: number; as?: ElementType; className?: string }) {
  const Comp = props.as ?? 'div'
  return (
    <Comp className={cn('animate-appear', props.className)} style={{ animationDelay: `${props.delay ?? 0}ms` }}>
      {props.children}
    </Comp>
  )
}
